(() => {
  const openSubmenuBtns = document.querySelectorAll(
    ".js-open-mobile-menu-item"
  );

  const closeSubmenuBtns = document.querySelectorAll(
    ".js-close-mobile-submenu"
  );

  Array.from(openSubmenuBtns).forEach((opener) => {
    opener.addEventListener("click", () => {
      const menuClasses = opener.classList;
      let menuToFind = ".js-mobile-menu-";
      menuClasses.forEach((className) => {
        if (className.includes("js-opener-of-")) {
          menuToFind = menuToFind.concat(
            className.replace("js-opener-of-", "")
          );
        }
      });
      const menuToOpen = document.querySelector(menuToFind);

      const menuToClose = opener.closest(".js-mobile-menu-parent");

      menuToClose.style.maxHeight = `${menuToClose.scrollHeight}px`;
      menuToClose.classList.remove("mobile-menu-child--show");
      menuToClose.classList.add("mobile-menu-child--hide");
      menuToClose.style.maxHeight = `${0}px`;

      menuToOpen.classList.remove("mobile-menu-child--hide");
      menuToOpen.classList.add("mobile-menu-child--show");
      menuToOpen.style.maxHeight = `${menuToOpen.scrollHeight}px`;
    });
  });

  Array.from(closeSubmenuBtns).forEach((closer) => {
    closer.addEventListener("click", () => {
      const menuClasses = closer.classList;
      const menuToClose = closer.parentElement;

      let menuToFind = ".js-mobile-menu-";

      menuClasses.forEach((className) => {
        if (className.includes("js-closer-to-")) {
          menuToFind = menuToFind.concat(
            className.replace("js-closer-to-", "")
          );
        }
      });

      const menuToOpen = document.querySelector(menuToFind);

      menuToClose.style.maxHeight = `${menuToClose.scrollHeight}px`;
      menuToClose.classList.remove("mobile-menu-child--show");
      menuToClose.classList.add("mobile-menu-child--hide");
      menuToClose.style.maxHeight = `${0}px`;

      menuToOpen.classList.remove("mobile-menu-child--hide");
      menuToOpen.classList.add("mobile-menu-child--show");
      menuToOpen.style.maxHeight = `${menuToOpen.scrollHeight}px`;
    });
  });
})();
